import React, { useEffect, useState } from 'react'
import { TextField, MenuItem } from '@mui/material'
import { useProductOrigins } from '../../../hooks'
import { ProductOrigin } from '../../../interfaces/Producto/ProductOrigins'

interface ProductOriginsDDLProps {
  onChange: any
  value: any
  type?: 'outlined' | 'filled' | 'standard' | undefined
  fullWidth?: boolean
  valueKey?: 'productOriginId' | 'origin'
  required?: boolean
  disabled?: boolean
  size?: 'small' | 'medium' | undefined
  typeStorages?: number[] | undefined
  error?: boolean
  errorText?: string
}

export const ProductOriginsDDL: React.FC<ProductOriginsDDLProps> = ({
  onChange,
  value,
  type,
  fullWidth = false,
  valueKey = 'productOriginId',
  required = false,
  disabled = false,
  typeStorages = undefined,
  size,
  error = false,
  errorText = 'Seleccionar Origen'
}) => {
  const [hasError, setHasError] = useState<boolean>(false)

  const {
    productOriginsState: { productOrigins },
    getProductOrigins
  } = useProductOrigins()

  useEffect(() => {
    if (productOrigins?.length === 0) {
      getProductOrigins()
    }
  }, [])

  useEffect(() => {
    // Validar si es obligatorio y si se ha seleccionado alguna opción
    if (required && value <= 0) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [value, required])

  const arrTypePositions =
    productOrigins !== undefined
      ? productOrigins
          .filter((item: ProductOrigin) => {
            // Si typeStorages no está definido o está vacío, mostramos todos los ítems.
            if (typeStorages === undefined || typeStorages.length === 0) {
              return true
            }
            // Si typeStorages sí tiene elementos, filtramos por ellos.
            return typeStorages.includes(item.typeStorageId)
          })
          .map((option: ProductOrigin) => (
            <MenuItem key={option[valueKey]} value={option[valueKey]}>
              {option.name}
            </MenuItem>
          ))
      : []

  const isError = () => {
    return hasError || error
  }

  return (
    <TextField
      variant={type}
      id='productOriginId'
      name='productOriginId'
      select
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      disabled={disabled}
      size={size}
      error={isError()}
      helperText={isError() ? errorText : undefined}
    >
      <MenuItem key={0} value={0}>
        {'Seleccione Marca ...'}
      </MenuItem>
      {arrTypePositions}
    </TextField>
  )
}
